import React, { Fragment, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import Layout from '../../../Layout'
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock'
import { Link } from 'react-router-dom'
import { Col, ConfigProvider, DatePicker, Pagination, PaginationProps, Row, TreeSelect } from 'antd'
import { getSLUnitByPermission } from '../../../api/selectOptions/selectOptionsApi'
import { convertNationwideValueToTree_V2 } from '../../../api/unit/unitApi'
import { useSelector } from 'react-redux'
import { selectorInfoUser } from '../../../store/slices/infoUserSlice'
import viVN from 'antd/locale/vi_VN';
import './styles.scss'
import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons'
import useDebounce from '../../../hook/useDebounce'
import { formatNumber } from '../../../services/mixin'
import { dataPagination } from '../../../until'
export interface TreeNode {
    id: string;
    name: string;
    level: number;

    children?: TreeNode[];

    metrics?: Record<
        string,
        {
            value: number;
            target: number;
        }
    >;
}

export interface ColumnDef {
    key: string;
    title: string;
    width: number;
}


export interface Metric {
    value: number;
    target: number;
}

// export interface TreeNode {
//     id: string;
//     name: string;
//     level: number;

//     children?: TreeNode[];

//     metrics?: Record<string, Metric>;
// }

// export interface ColumnDef {
//     key: string;
//     title: string;
//     width: number;
// }

const defaultColumns: ColumnDef[] = [
    {
        key: "name",
        title: "Công ty tỉnh thành",
        width: 320
    },

    {
        key: "cccd",
        title: "CCCD/Hộ chiếu",
        width: 130
    },

    {
        key: "mst",
        title: "Mã số thuế",
        width: 130
    },

    {
        key: "birthday",
        title: "Ngày sinh",
        width: 120
    },

    {
        key: "gender",
        title: "Giới tính",
        width: 120
    },

    {
        key: "phone",
        title: "Số điện thoại",
        width: 130
    },

    {
        key: "email",
        title: "Email",
        width: 120
    },

    {
        key: "address",
        title: "Địa chỉ",
        width: 120
    },

    {
        key: "income",
        title: "Thu nhập",
        width: 120
    },

    {
        key: "job",
        title: "Nghề nghiệp",
        width: 120
    },

    {
        key: "average",
        title: "Trung bình",
        width: 120
    }
];
const treeData: TreeNode[] = [
    {
        id: "south",
        name: "Cty TT/DL Phía Nam",
        level: 0,

        children: [
            {
                id: "hcm",
                name: "THACO AUTO TP.HCM",
                level: 1,

                children: [
                    {
                        id: "govap",
                        name: "SR Gò Vấp",
                        level: 2,

                        metrics: {
                            cccd: {
                                value: 75,
                                target: 80
                            },

                            mst: {
                                value: 75,
                                target: 80
                            },

                            birthday: {
                                value: 85,
                                target: 80
                            },

                            gender: {
                                value: 90,
                                target: 80
                            },

                            phone: {
                                value: 65,
                                target: 80
                            },

                            email: {
                                value: 90,
                                target: 80
                            },

                            address: {
                                value: 70,
                                target: 80
                            },

                            income: {
                                value: 95,
                                target: 80
                            },

                            job: {
                                value: 80,
                                target: 80
                            },

                            average: {
                                value: 78,
                                target: 80
                            }
                        }
                    },

                    {
                        id: "binhtrieu",
                        name: "SR Bình Triệu",
                        level: 2,

                        metrics: {
                            cccd: {
                                value: 85,
                                target: 80
                            },

                            mst: {
                                value: 88,
                                target: 80
                            },

                            average: {
                                value: 86,
                                target: 80
                            }
                        }
                    }
                ]
            }
        ]
    },

    {
        id: "north",
        name: "Cty TT/DL Phía Bắc",
        level: 0,

        children: [
            {
                id: "hanoi",
                name: "THACO AUTO Hà Nội",
                level: 1,

                children: [
                    {
                        id: "longbien",
                        name: "SR Long Biên",
                        level: 2,

                        metrics: {
                            cccd: {
                                value: 95,
                                target: 80
                            },

                            mst: {
                                value: 95,
                                target: 80
                            },

                            average: {
                                value: 95,
                                target: 80
                            }
                        }
                    }
                ]
            }
        ]
    }
];
const TableReportDataByCity = () => {
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });

    const [expanded, setExpanded] =
        useState<Record<string, boolean>>(
            {}
        );
    const [treeColWidths, setTreeColWidths] =
        useState<
            Record<string, number>
        >(() =>
            Object.fromEntries(
                defaultColumns.map(
                    col => [
                        col.key,
                        col.width
                    ]
                )
            )
        );
    const getTreeWidth = (
        col: ColumnDef
    ) =>
        treeColWidths[col.key] ??
        col.width;

    const resizingRef =
        useRef<{
            columnKey: string;
            startX: number;
            startWidth: number;
        } | null>(null);


    const handleResizeStart = (
        e: React.MouseEvent,
        col: ColumnDef
    ) => {
        e.preventDefault();

        resizingRef.current = {
            columnKey: col.key,
            startX: e.clientX,
            startWidth:
                getTreeWidth(col)
        };
    };


    const buildExpandedMap = (
        nodes: TreeNode[]
    ) => {
        const result: Record<
            string,
            boolean
        > = {};

        const walk = (
            items: TreeNode[]
        ) => {
            items.forEach(item => {
                if (
                    item.children?.length
                ) {
                    result[item.id] =
                        true;

                    walk(
                        item.children
                    );
                }
            });
        };

        walk(nodes);

        return result;
    };
    const flattenTree = (
        nodes: TreeNode[]
    ): TreeNode[] => {
        const result: TreeNode[] =
            [];

        const walk = (
            items: TreeNode[]
        ) => {
            items.forEach(item => {
                result.push(item);

                if (
                    item.children
                        ?.length &&
                    expanded[item.id]
                ) {
                    walk(
                        item.children
                    );
                }
            });
        };

        walk(nodes);

        return result;
    };
    const rows = useMemo(
        () =>
            flattenTree(
                treeData
            ),
        [expanded]
    );
    const toggleNode = (
        id: string
    ) => {
        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const gListCustomerVehicleOwnershipReportByBrand = useDebounce(async (pageCurent: number = 1, pageSize: number = 10,) => {
        // if (!brandId) {
        //     navigate(-1)
        //     return
        // }
        // const result = await getListCustomerVehicleOwnershipReportByBrand(
        //     pageSize,
        //     pageCurent,
        //     brandId,
        //     type,
        //     unitIdDefault,
        //     dataFilter
        // )
        // if (result?.status) {
        //     setPagination({ current: pageCurent, pageSize, total: result?.total })
        //     // setDataCarOwnedBrandByUnit(formatVehicleOwnershipChart(resultCarOwnedBrandByUnit.data))
        //     setDataVehicleOwnershipReportByBrandTable(mapCustomerData(result?.data))

        // } else {
        //     pushToast(result?.message, "error")
        //     navigate(-1)
        // }
    }, 1000)
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
        gListCustomerVehicleOwnershipReportByBrand(pageNumber, pageSize)
    }



    useEffect(() => {
        gListCustomerVehicleOwnershipReportByBrand()
    }, [])


    useEffect(() => {
        setExpanded(
            buildExpandedMap(
                treeData
            )
        );
    }, []);

    useEffect(() => {
        const handleMove = (
            e: MouseEvent
        ) => {
            if (
                !resizingRef.current
            )
                return;

            const {
                columnKey,
                startX,
                startWidth
            } = resizingRef.current;

            const width =
                startWidth +
                (e.clientX -
                    startX);

            setTreeColWidths(prev => ({
                ...prev,

                [columnKey]:
                    Math.max(
                        80,
                        width
                    )
            }));
        };

        const handleUp = () => {
            resizingRef.current =
                null;
        };

        window.addEventListener(
            "mousemove",
            handleMove
        );

        window.addEventListener(
            "mouseup",
            handleUp
        );

        return () => {
            window.removeEventListener(
                "mousemove",
                handleMove
            );

            window.removeEventListener(
                "mouseup",
                handleUp
            );
        };
    }, []);
    return (
        <div className='custom-page-css flex flex-col gap-2'>

            <div className="custom-page-css flex flex-col pt-4">
                <span className='custom-page-css text-344054 font-medium text-base'>Báo cáo chất lượng dữ liệu theo công ty tỉnh thành</span>
                <span className='custom-page-css text-344054 font-regular text-sm text-italic'>
                    Người dùng có thể click chuột trực tiếp vào tỷ lệ để kiểm tra chi tiết thông tin.</span>
            </div>

            <div className="tree-table-wrapper">
                <table
                    className="tree-table"
                    style={{
                        width: defaultColumns.reduce(
                            (sum, col) =>
                                sum + getTreeWidth(col),
                            0
                        )
                    }}
                >
                    <colgroup>
                        {defaultColumns.map(col => (
                            <col
                                key={col.key}
                                style={{
                                    width: getTreeWidth(col)
                                }}
                            />
                        ))}
                    </colgroup>

                    <thead>
                        {/* HEADER LEVEL 1 */}
                        <tr className="header-level-1">
                            <th
                                rowSpan={2}
                                className=""
                            >
                                Công ty tỉnh thành

                                <div
                                    className="resize-handle"
                                    onMouseDown={e =>
                                        handleResizeStart(
                                            e,
                                            defaultColumns[0]
                                        )
                                    }
                                />
                            </th>

                            <th
                                colSpan={4}
                                className="group-header"
                            >
                                Thông tin định danh
                            </th>

                            <th
                                colSpan={3}
                                className="group-header"
                            >
                                Thông tin liên hệ
                            </th>

                            <th
                                colSpan={4}
                                className="group-header"
                            >
                                Thông tin làm giàu
                            </th>

                            <th rowSpan={2}>
                                Trung bình
                            </th>
                        </tr>

                        {/* HEADER LEVEL 2 */}
                        <tr className="header-level-2">
                            {defaultColumns
                                .filter(
                                    c =>
                                        c.key !==
                                        "name"
                                )
                                .map(col => (
                                    <th
                                        key={col.key}
                                        style={{
                                            width:
                                                getTreeWidth(
                                                    col
                                                ),
                                            minWidth:
                                                getTreeWidth(
                                                    col
                                                )
                                        }}
                                    >
                                        {col.title}

                                        <div
                                            className="resize-handle"
                                            onMouseDown={e =>
                                                handleResizeStart(
                                                    e,
                                                    col
                                                )
                                            }
                                        />
                                    </th>
                                ))}
                        </tr>
                        {/* KPI */}
                        <tr className="kpi-row">
                            <td className="tree-column">
                                KPI
                            </td>

                            {defaultColumns
                                .filter(
                                    c =>
                                        c.key !==
                                        "name"
                                )
                                .map(col => (
                                    <td
                                        key={col.key}
                                        className="metric-cell"
                                    >
                                        ≥ 80%
                                    </td>
                                ))}
                        </tr>
                    </thead>

                    <tbody>


                        {/* DATA */}
                        {rows.map(row => (
                            <tr
                                key={row.id}
                                className={
                                    row.children
                                        ?.length
                                        ? "group-node"
                                        : ""
                                }
                            >
                                <td
                                    className="tree-column"
                                    style={{
                                        width:
                                            getTreeWidth(
                                                defaultColumns[0]
                                            ),
                                        minWidth:
                                            getTreeWidth(
                                                defaultColumns[0]
                                            )
                                    }}
                                >
                                    <div
                                        className="tree-cell"
                                        style={{
                                            paddingLeft:
                                                12 +
                                                row.level *
                                                24
                                        }}
                                    >
                                        {row.children
                                            ?.length ? (
                                            <span
                                                className="expand-icon"
                                                onClick={() =>
                                                    toggleNode(
                                                        row.id
                                                    )
                                                }
                                            >
                                                {expanded[
                                                    row.id
                                                ]
                                                    ? <CaretDownOutlined />
                                                    : <CaretRightOutlined />}
                                            </span>
                                        ) : (
                                            <span
                                                className="empty-icon"
                                            />
                                        )}

                                        <span>
                                            {
                                                row.name
                                            }
                                        </span>
                                    </div>
                                </td>

                                {defaultColumns
                                    .filter(
                                        c =>
                                            c.key !==
                                            "name"
                                    )
                                    .map(col => {
                                        const metric =
                                            row.metrics?.[
                                            col.key
                                            ];

                                        const value =
                                            metric?.value;

                                        const target =
                                            metric?.target;

                                        return (
                                            <td
                                                key={
                                                    col.key
                                                }
                                                className={
                                                    value &&
                                                        target &&
                                                        value <
                                                        target
                                                        ? "metric-danger"
                                                        : "metric-cell"
                                                }
                                            >
                                                {value
                                                    ? `${value}%`
                                                    : "--"}
                                            </td>
                                        );
                                    })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        className='rs-pagination'
                        showSizeChanger
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                        pageSizeOptions={[10, 20, 50, 100]}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                        onChange={onPaginationChange}
                    />
                </div>
            </ConfigProvider>
        </div>
    );
};
export default TableReportDataByCity;